/* global JSX */
// Button
// ***********************************************************************************************************************
import * as React from "react";
import { DialogButtonType, DialogButtonSize } from "./../../models/enums";

export interface IButtonProp {
    autoFocus?: boolean;
    buttonType: DialogButtonType;
    buttonSize?: DialogButtonSize;
    disabled?: boolean;
    hidden?: boolean;
    icon?: string;
    index?: number;
    classes?: string;
    preventDefault?: boolean;
    stopPropagation?: boolean;
    title?: string | JSX.Element;
    tooltip?: string;
    onClick: (index?: number) => void;
}

export class Button extends React.Component<IButtonProp, {}> {
    static callOnClick(onClick: () => void) {
        const activeElement: any = document.activeElement;
        if (activeElement && activeElement.blur) {
            activeElement.blur();
            window.setTimeout(() => {
                onClick();
            }, 50);
        } else {
            onClick();
        }
    }

    handleClick = (e) => {
        const props = this.props;
        if (!!props.disabled || !props.onClick) return;
        if (props.stopPropagation) {
            e.stopPropagation();
        }
        if (props.preventDefault) {
            e.preventDefault();
        }
        Button.callOnClick(props.onClick);
    };

    render() {
        const props = this.props;
        if (props.hidden) return null;
        const tooltip = props.tooltip ? props.tooltip : (typeof props.title === "string" ? props.title : null);
        const buttonTypeClass = props.buttonType === DialogButtonType.Danger
            ? "btn-danger"
            : (props.buttonType === DialogButtonType.Primary
                ? "btn-primary"
                : (props.buttonType === DialogButtonType.Default
                    ? "btn-default"
                    : ""));
        const buttonSizeClass = !props.buttonSize
            ? ""
            : (props.buttonSize === DialogButtonSize.Small
                ? " btn-sm"
                : (props.buttonSize === DialogButtonSize.Large
                    ? " btn-lg"
                    : " btn-vsm"));
        const buttonClasses = "btn " + buttonTypeClass + buttonSizeClass + (props.classes ? " " + props.classes : "") + (props.disabled ? " disabled" : "");
        return (
            <button type="button" className={buttonClasses} title={tooltip} onClick={this.handleClick} autoFocus={!!props.autoFocus} disabled={!!props.disabled}>{props.title}{props.icon ? <div className={"iconBtn icon " + props.icon}></div> : ""}</button>
        );
    }
}